//libraries
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Link as ReactRouterLink } from 'react-router-dom';

// styles
import { Flex } from 'shared/styledComponents';
import { Eyebrow } from 'shared/typography';

const ServicesWrapper = styled(Flex)<any>`
  flex-wrap: wrap;
  justify-content: ${({ isRelatedArticle }): string => (isRelatedArticle ? 'flex-start' : 'center')};
  margin-bottom: 25px;
`;

const Service = styled(Eyebrow)`
  line-height: 25px;
`;

const Space = styled(Eyebrow)`
  line-height: 25px;
  text-decoration: none;
`;

const ServicesBlock = ({ services, isRelatedArticle }: any): JSX.Element => (
  <ServicesWrapper isRelatedArticle={isRelatedArticle}>
    {!!services.length &&
      services.map((service: any) =>
        services[services.length - 1] === service ? (
          <Service
            key={service.id}
            as={ReactRouterLink}
            to={`/service/${service?.value?.split(' ').join('-').toLowerCase()}`}
          >
            {service.value}
          </Service>
        ) : (
          <Fragment key={service.id}>
            <Service as={ReactRouterLink} to={`/service/${service?.value?.split(' ').join('-').toLowerCase()}`}>
              {service.value}
            </Service>
            <Space>,&nbsp;</Space>
          </Fragment>
        ),
      )}
  </ServicesWrapper>
);

export default ServicesBlock;
